import {NgModule} from '@angular/core';
import {AisCommonComponent} from './ais-common.component';
import {AppHeaderComponent} from './app-header/app-header.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {AppFooterComponent} from './app-footer/app-footer.component';
import {CommonModule} from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {RouterModule} from '@angular/router';
import {AuthErrorComponent} from './auth-error/auth-error.component';
import {ErrorDialogComponent} from './error-dialog/error-dialog.component';
import {ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';
import {OkDialogComponent} from './ok-dialog/ok-dialog.component';
import {AisDatePipe} from './ais-date.pipe';
import {AnoNiePipe} from './ano-nie.pipe';
import { PasswordChangeComponent } from './password-change/password-change.component';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DialogHeaderComponent} from './components/dialog-header/dialog-header.component';


@NgModule({
    declarations: [
        AisCommonComponent,
        AppHeaderComponent,
        AppFooterComponent,
        PageNotFoundComponent,
        AuthErrorComponent,
        ErrorDialogComponent,
        ConfirmDialogComponent,
        OkDialogComponent,
        AisDatePipe,
        AnoNiePipe,
        PasswordChangeComponent,
        DialogHeaderComponent
    ],
    exports: [
        AisCommonComponent,
        AppHeaderComponent,
        AppFooterComponent,
        ErrorDialogComponent,
        ConfirmDialogComponent,
        OkDialogComponent,
        AisDatePipe,
        AuthErrorComponent,
        AnoNiePipe,
        DialogHeaderComponent,
    ],
    imports: [
        MatIconModule,
        CommonModule,
        RouterModule,
        MatDialogModule,
        FormsModule,
        TranslateModule,
        MatButtonModule,
        MatTooltipModule,
        MatDialogModule,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AisCommonModule { }
